export enum TranslationTab {
  AI = 'AI',
  MANUAL = 'MANUAL',
}
